import React, { useState, useContext } from "react"
import { NavLink } from "react-router-dom"
import {
  SidebarCategory,
  SidebarSubCategory,
  SidebarLink,
  SidebarSubLink,
} from "."
import _ from "lodash"
import { JSUtils } from "@utils"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { useStyles } from "./style"
import { Collapse } from "@material-ui/core"
import { DashboardContext } from "@utils"

const getReadWritePermissions = (x, userPermAttr = {}) =>
  JSUtils.getReadWritePermissions(x, userPermAttr)
const TooltipSideBar = (props) => {
  const { routeName, formatRoutes } = props
  const history = useHistory()
  const { showMore, setShowMore } = useContext(DashboardContext)
  const classesOne = useStyles()
  const { t } = useTranslation()
  const [routesWithActiveStatus, setRoutesWithActiveStatus] = useState(
    formatRoutes(_.cloneDeep(routeName))
  )
  const userPermAttr = useSelector(
    (state) => state.adminReducer.userKeycloakAttributes
  )

  const userProfileDetails =
    useSelector((state) => state.adminReducer.userProfileDetails) || {}

  const handleToggle = (indicesArr, route = {}) => {
    const { redirect = true } = route
    const tempRoutes = _.cloneDeep(routesWithActiveStatus)
    if (_.isArray(indicesArr)) {
      let isOnly = indicesArr.length === 1
      let path = indicesArr.reduce((acc, x, i, arr) => {
        let isFirst = i === 0
        let isLast = arr.length - 1 === i
        acc = `${isFirst ? "" : `${acc}.`}${x}${isLast ? "" : ".children"}`
        return acc
      }, "")
      _.set(tempRoutes, path, {
        ..._.get(tempRoutes, path),
        isOpen: !_.get(tempRoutes, `${path}.isOpen`),
      })
    }
    setRoutesWithActiveStatus(tempRoutes)
    if (redirect) {
      if (_.has(route, "path"))
        history.push(`/${userProfileDetails?.roleType}${_.get(route, "path")}`)
    }
  }

  return (
    <>
      {routeName?.map((category, index) => {
        let { isReadAllowed: isCategoryAllowed } = getReadWritePermissions(
          category,
          userPermAttr
        )
        let allowedHeadModule = []
        let allowedSubHeadModule = []
        _.map(category?.children, (ro, i) => {
          allowedHeadModule.push(
            getReadWritePermissions(ro, userPermAttr).isReadAllowed
          )
          _.map(ro?.children, (rou, i) => {
            allowedSubHeadModule.push(
              getReadWritePermissions(rou, userPermAttr).isReadAllowed
            )
          })
        })
        const categorySiblingPaths = _.compact(
          _.map(category?.children, (item) =>
            item?.path
              ? `/${userProfileDetails?.roleType}${item.path}`
              : null
          )
        )
        return (
          <div>
            {isCategoryAllowed &&
            category.children &&
            category.icon &&
            !allowedHeadModule.every((x) => x === false) ? (
              <React.Fragment key={index}>
                <SidebarCategory
                  isOpen={_.get(
                    routesWithActiveStatus,
                    `${index}.isOpen`,
                    false
                  )}
                  isCollapsable={false}
                  name={t(category.id)}
                  button={true}
                  onClick={() => handleToggle([index])}
                />
                {category?.children?.map((route, ind) => {
                  let {
                    isReadAllowed: isRouteAllowed,
                  } = getReadWritePermissions(route, userPermAttr)
                  if (route.children && isRouteAllowed) {
                    const subSiblingPaths = _.compact(
                      _.map(route.children, (item) =>
                        item?.path
                          ? `/${userProfileDetails?.roleType}${item.path}`
                          : null
                      )
                    )
                    return (
                      <>
                        {route.children &&
                        !allowedSubHeadModule.every((x) => x === false) ? (
                          <React.Fragment key={`sidebarsubcategory_${ind}`}>
                            <SidebarSubCategory
                              isOpen={_.get(
                                routesWithActiveStatus,
                                `${index}.children.${ind}.isOpen`,
                                false
                              )}
                              isCollapsable={true}
                              name={t(route.id)} // master auto frition;
                              button={true}
                              onClick={() => handleToggle([index, ind], route)}
                            />
                            <Collapse
                              in={_.get(
                                routesWithActiveStatus,
                                `${index}.children.${ind}.isOpen`,
                                false
                              )}
                              timeout="auto"
                              unmountOnExit
                              className={classesOne.collapse}
                            >
                              {route.children.map((r, i) => {
                                let {
                                  isReadAllowed: isChildRouteAllowed,
                                } = getReadWritePermissions(r, userPermAttr)
                                if (isChildRouteAllowed) {
                                  return (
                                    <React.Fragment key={`sidebarsublink_${i}`}>
                                      <SidebarSubLink
                                        key={`sidebarsublink_${i}`}
                                        name={t(r.name)}
                                        to={`/${userProfileDetails?.roleType}${r.path}`} ////group ,product ,group
                                        badge={r.badge}
                                        siblingPaths={subSiblingPaths}
                                        onClick={() => {
                                          history.push(route.path)
                                        }}
                                      />
                                    </React.Fragment>
                                  )
                                }
                                return null
                              })}
                            </Collapse>
                          </React.Fragment>
                        ) : null}
                      </>
                    )
                  } else {
                    return (
                      isRouteAllowed && (
                        <React.Fragment key={`sidebarsubcategory_${ind}`}>
                          <SidebarLink // plonogram,inventory, userMangement,permission,role permission,country,tax masterData
                            isRouteAllowed={getReadWritePermissions(
                              route,
                              userPermAttr
                            )}
                            route={route}
                            routePerms={getReadWritePermissions(
                              route,
                              userPermAttr
                            )}
                            key={`sidebarsubcategory_${ind}`}
                            name={t(route.name)}
                            to={`/${userProfileDetails?.roleType}${route.path}`}
                            icon={route.icon}
                            badge={route.badge}
                            siblingPaths={categorySiblingPaths}
                          />
                        </React.Fragment>
                      )
                    )
                  }
                })}
              </React.Fragment>
            ) : (
              <>
                {isCategoryAllowed &&
                category.icon &&
                allowedHeadModule.every((x) => x !== false) ? (
                  <React.Fragment key={`sidebarCategory_${index}`}>
                    <SidebarCategory
                      isCollapsable={false}
                      name={t(category.id)}
                      to={`/${userProfileDetails?.roleType}${category.path}`}
                      activeclassname="active"
                      component={NavLink}
                      exact={false}
                      button
                      badge={category.badge}
                      key={index}
                    />
                  </React.Fragment>
                ) : null}
              </>
            )}
          </div>
        )
      })}
    </>
  )
}
export default TooltipSideBar
